<style>
thead {
  background-color: #3d3d3d;
}

.v-data-table
  .v-table__wrapper
  > table
  > thead
  > tr
  > th.v-data-table__th--sortable:hover,
.v-data-table
  .v-table__wrapper
  > table
  tbody
  > tr
  > th.v-data-table__th--sortable:hover {
  cursor: unset;
}

.v-main {
  background-color: #dfdfdf;
}

.h2,
h2 {
  margin-bottom: 10px;
  font-weight: 600;
  border-bottom: 1px solid;
  font-size: 20px;
}

.v-table > .v-table__wrapper > table > thead > tr > th {
  padding: 0 7px !important;
}
</style>

<template>
  <div
    style="
      padding: 20px;
      margin: 20px;
      background-color: white;
      border-radius: 10px;
    "
  >
    <h2 style="margin-bottom: 15px; font-weight: 600; border-bottom: 1px solid">
      Filtros
    </h2>

    <div class="d-flex flex-wrap ga-3">
      <div class="w-in">
        <label>N° Solicitud:</label>
        <v-text-field
          v-model="solId"
          type="number"
          pa-1
          hide-details
          ma-0
          variant="solo"
          clearable
          autocomplete="off"
          color="primary"
        />
      </div>

      <div class="w-in">
        <label>Ingresado Por:</label>

        <v-combobox
          v-model="solicitantePor"
          :items="lstSolicitantes"
          variant="solo"
          pa-1
          ma-0
          autocomplete="off"
          hide-details
          item-title="rutDisplayName"
          item-value="rut"
          clearable
          :disabled="
            !esAprobador &&
            !esAprobadorRespel &&
            !esAutorizador &&
            !esBodeguero &&
            !esContabilidad &&
            !esComprador &&
            !esVisualizador &&
            !esVisorRendiciones &&
            !esAdmin
          "
        >
        </v-combobox>
      </div>

      <div class="w-in">
        <label>Solicitado Por:</label>

        <v-combobox
          v-model="solicitante"
          :items="lstSolicitantes"
          variant="solo"
          pa-1
          hide-details
          autocomplete="off"
          ma-0
          item-title="rutDisplayName"
          item-value="rut"
          clearable
        >
        </v-combobox>
      </div>

      <div class="w-in">
        <label>Tipo Solicitud:</label>

        <v-combobox
          pa-1
          hide-details
          ma-0
          autocomplete="off"
          v-model="tipoSol"
          :items="lstTipoSolicitud"
          variant="solo"
          item-title="id"
          item-value="nombre"
          @update:modelValue="seleccionarRetiroBodega"
        >
        </v-combobox>
      </div>

      <div class="w-in">
        <label>Fecha Desde:</label>
        <v-text-field
          v-model="desde"
          type="date"
          hide-details
          autocomplete="off"
          pa-1
          ma-0
          variant="solo"
          color="primary"
        />
      </div>

      <div class="w-in">
        <label>Fecha Hasta:</label>
        <v-text-field
          v-model="hasta"
          type="date"
          autocomplete="off"
          hide-details
          pa-1
          ma-0
          variant="solo"
          color="primary"
        />
      </div>

      <div class="w-in">
        <label>Empresa:</label>

        <v-combobox
          v-model="empresaSel"
          :items="lstEmpresas"
          variant="solo"
          pa-1
          autocomplete="off"
          hide-details
          ma-0
          item-title="displayName"
          item-value="id"
          clearable
          @update:modelValue="selectCompany"
          @click:clear="selectClear"
        >
        </v-combobox>
      </div>

      <div class="w-in">
        <label>Departamento:</label>

        <v-combobox
          v-model="departamentoSel"
          :items="lstDepartamento"
          variant="solo"
          pa-1
          autocomplete="off"
          hide-details
          ma-0
          item-title="codeDisplayName"
          item-value="id"
          clearable
        >
        </v-combobox>
      </div>

      <div class="w-in">
        <label>Estado:</label>

        <v-combobox
          pa-1
          ma-0
          hide-details
          v-model="estadoSel"
          :items="lstEstados"
          autocomplete="off"
          variant="solo"
          item-title="id"
          item-value="nombre"
        >
        </v-combobox>
      </div>

      <div class="w-in">
        <div v-if="tipoSol?.id == 'Todos' || tipoSol?.id == 'Compra'">
          <label>Comprador:</label>

          <v-autocomplete
            v-model="compradorSel"
            :items="lstCompradores"
            variant="solo"
            item-title="name"
            item-value="code"
            autocomplete="off"
            clearable
            hide-details
            return-object
          >
          </v-autocomplete>
        </div>

        <div v-if="tipoSol?.id == 'Retiro Bodega'">
          <label>Bodegas:</label>

          <v-combobox
            variant="solo"
            :items="lstBodegas"
            hide-details
            pa-1
            ma-0
            autocomplete="off"
            clearable
            item-title="codeDisplayName"
            item-value="code"
            return-object
            v-model="bodegaSel"
          >
          </v-combobox>
        </div>
      </div>

      <div class="w-in">
        <label>Proveedor:</label>

        <v-autocomplete
          v-model="vendorSel"
          :items="lstVendors"
          variant="solo"
          item-title="numberDisplayName"
          item-value="id"
          clearable
          autocomplete="off"
          hide-details
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in">
        <label>Ceco:</label>

        <v-autocomplete
          v-model="cecoSel"
          :items="lstCeco"
          variant="solo"
          item-title="codeDisplayName"
          item-value="id"
          clearable
          autocomplete="off"
          hide-details
          return-object
        >
        </v-autocomplete>
      </div>

      <div class="w-in">
        <label>Num. BC365:</label>
        <v-text-field
          v-model="bc365"
          pa-1
          hide-details
          ma-0
          autocomplete="off"
          variant="solo"
          clearable
          color="primary"
        />
      </div>

      <div class="w-in">
        <label>Proyectos:</label>

        <v-combobox
          v-model="proyectoSel"
          :items="lstProyectos"
          variant="solo"
          pa-1
          autocomplete="off"
          hide-details
          ma-0
          item-title="codeDisplayName"
          item-value="id"
          clearable
        >
        </v-combobox>
      </div>

      <div style="display: inline-flex" class="w-btn">
        <v-btn
          style="
            background-color: #a3a3a3;
            padding: 15px;
            border-radius: 15px;
            margin-top: 1em;
            color: white;
            margin-left: auto;
            display: flex;
          "
          density="default"
          @click="limpiarBusqueda()"
        >
          Limpiar
        </v-btn>
        <v-btn
          style="
            background-color: #595959;
            padding: 15px;
            border-radius: 15px;
            margin-top: 1em;
            color: white;
            margin-left: 10px;
            margin-right: auto;
            display: flex;
          "
          density="default"
          @click="buscarSolicitudClick"
        >
          Buscar
        </v-btn>
      </div>
    </div>

    <div style="margin-top: 20px">
      <div style="display: inline-flex; float: right">
        <v-btn
          prepend-icon="mdi-export"
          @click="exportarSolicitudClick"
          style="
            margin: 5px 0px 10px 7px;
            background-color: rgb(166 26 47);
            border-radius: 15px;
            color: white;
            margin-bottom: 8px;
          "
        >
          <template v-slot:prepend>
            <v-icon color="white"></v-icon>
          </template>

          Exportar
        </v-btn>
      </div>

      <v-data-table-server
        :headers="headers"
        :items="lstDetalle"
        v-model:items-per-page="itemsPerPage"
        :items-length="totalItems"
        @update:options="buscarSolicitud($event, false)"
        :items-per-page-options="[10, 25, 50]"
      >
        <template v-slot:item.code="{ item }">
          {{ item.code ? "SOC-" + item.code.toString().padStart(7, "0") : "" }}
        </template>

        <template v-slot:item.fechaSolicitud="{ item }">
          {{ formatDate(item.fechaSolicitud ?? "") }}
        </template>

        <!-- <template v-slot:item.retBodega="{ item }">
                  <v-checkbox
                    variant="outlined"
                    density="compact"
                    hide-details
                    v-model="item.retBodega"
                  >
                  </v-checkbox>
                </template> -->

        <template v-slot:item.total="{ item }">
          {{ formatTotal(item.total ?? 0) }}
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon
            icon="mdi-chevron-right"
            color="red"
            @click="navigate(item)"
          />
        </template>
      </v-data-table-server>
    </div>
  </div>

  <v-overlay
    :model-value="isLoading"
    class="align-center justify-center"
    persistent
  >
    <v-progress-circular
      color="#a61a2f"
      size="50"
      :width="5"
      indeterminate
    ></v-progress-circular>
  </v-overlay>
</template>

<script setup lang="ts">
import axios from "axios";
import type { Ref } from "vue";
import { reactive, ref } from "vue";
import { onMounted } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";
import { useCookies } from "vue3-cookies";
import moment from "moment";
import swal from "sweetalert2";
import { useRouter, useRoute } from "vue-router";
import { normalizeTipoSolicitud } from "@/utils/tipoSolicitudHelpers";
import type { Empleado } from "../types/empleado";
import type { Departamento } from "../types/departamento";
import type { TipoSolicitud } from "../types/tipoSolicitud";
import type { Company } from "../types/company";
import type { Estado } from "../types/estado";
import type { Location } from "../types/location";
import type { Rol } from "../types/rol";
import type { BuscarSolicitud } from "../types/buscarSolicitud";
import type { Vendors } from "../types/vendors";
import type { Ceco } from "../types/ceco";
import type { Comprador } from "../types/comprador";
import type { Proyecto } from "../types/proyecto";

import useEmpresas from "../composables/useEmpresa";
import useDepartamentos from "../composables/useDepartamento";
import useComprador from "../composables/useComprador";
import useSolicitante from "../composables/useSolicitante";
import useVendors from "../composables/useVendors";
import useCeco from "../composables/useCeco";
import useProyecto from "../composables/useProyecto";

const store = useStore(key);
const { cookies } = useCookies();
const router = useRouter();
const route = useRoute();

const { getCompanies, lstEmpresas } = useEmpresas();
const { getDepartamentos, lstDepartamento } = useDepartamentos();
// const { getBodegas, lstBodegas } = useBodegas();
const { getCompradores, lstCompradores } = useComprador();
const { getSolicitantes, lstSolicitantes } = useSolicitante();
const { getVendors, lstVendors } = useVendors();
const { getCeco, lstCeco } = useCeco();
const { getProyectos, lstProyectos } = useProyecto();

const DEFAULT_TIPOS: TipoSolicitud[] = [
  { id: "Todos", nombre: "Todos" },
  { id: "Compra", nombre: "Compra" },
  { id: "Retiro Bodega", nombre: "Retiro Bodega" },
  { id: "Rendicion", nombre: "Rendicion" },
  { id: "Ingreso RESPEL", nombre: "Ingreso RESPEL" },
  { id: "Retiro RESPEL", nombre: "Retiro RESPEL" },
];

let lstTipoSolicitud: TipoSolicitud[] = DEFAULT_TIPOS.slice();

let lstEstados: Estado[] = [
  { id: "Todos", nombre: "Todos" },
  { id: "Aprobada", nombre: "Aprobada" },
  { id: "Anulada", nombre: "Anulada" },
  { id: "Autorizada", nombre: "Autorizada" },
  { id: "Cerrada", nombre: "Cerrada" },
  { id: "Creada", nombre: "Creada" },
  { id: "Despachado", nombre: "Despachado" },
  { id: "En Despacho", nombre: "En Despacho" },
  { id: "Enviada", nombre: "Enviada" },
  { id: "Guardada", nombre: "Guardada" },
  { id: "Rechazada", nombre: "Rechazada" },
];

let headers: any[] = [
  { title: "Id", key: "code", align: "center", width: "150px" },
  { title: "Tipo Solicitud", key: "tipoSolicitudId", align: "start" },
  { title: "Fecha Solicitud", key: "fechaSolicitud", align: "start" },
  { title: "Num. BC365", key: "bC365Id", width: "120px" },
  { title: "Empresa", key: "companyName", align: "center" },
  { title: "Departamento", key: "departamentoName", align: "center" },
  // { title: "Ingresado Por", key: "solicitantePorNombre", align: "start" },
  { title: "Proveedor", key: "vendorName", align: "start" },
  { title: "Solicitante Por", key: "solicitanteNombre", align: "start" },
  { title: "Comprador", key: "compradorName" },
  { title: "Total", key: "total" },
  { title: "Estado", key: "estado", align: "start" },
  { title: "", key: "actions", align: "start" },
];

let esComprador: Ref<boolean> = ref(false);
let esBodeguero: Ref<boolean> = ref(false);
let esAprobador: Ref<boolean> = ref(false);
let esAprobadorRespel: Ref<boolean> = ref(false);
let esContabilidad: Ref<boolean> = ref(false);
let esAutorizador: Ref<boolean> = ref(false);
let esVisualizador: Ref<boolean> = ref(false);
let esVisorRendiciones: Ref<boolean> = ref(false);

let tipoSol: Ref<TipoSolicitud | null> = ref(lstTipoSolicitud[0]);
let estadoSel: Ref<Estado | null> = ref(lstEstados[0]);
let isLoading = ref(false);
let solId: Ref<string> = ref("");
// let date: Ref<string> = ref("");

let desde: Ref<string> = ref("");
let hasta: Ref<string> = ref("");
// hasta.value = new Date(
//   Date.now() - new Date().getTimezoneOffset() * 60000 + 90 * 24 * 60 * 60 * 1000
// )
//   .toISOString()
//   .substr(0, 10);

let solicitantePor: Ref<Empleado | null> = ref(null);
let empresaSel: Ref<Company | null> = ref(null);
let departamentoSel: Ref<Departamento | null> = ref(null);
let bodegaSel: Ref<Location | null> = ref(null);
let compradorSel: Ref<Comprador | null> = ref(null);
let solicitante: Ref<Empleado | null> = ref(null);
let bc365: Ref<string> = ref("");
let lstDetalle: Ref<BuscarSolicitud[]> = ref([]);
let rut: string | null = null;
let lstBodegas: Ref<Location[]> = ref([]);
let esAdmin: Ref<boolean> = ref(false);
let currentUser: Ref<Empleado | null> = ref(null);
let vendorSel: Ref<Vendors | null> = ref(null);
let cecoSel: Ref<Ceco | null> = ref(null);
let proyectoSel: Ref<Proyecto | null> = ref(null);

let itemsPerPage: Ref<number> = ref(10);
let sortBy: Ref<string> = ref("");
let orderP: Ref<string> = ref("");
let keyOrderP: Ref<string> = ref("");
let totalItems: Ref<number> = ref(0);
let mountedFinish = ref(false);

onMounted(async () => {
  store.state.titulo = "Buscar Solicitud";

  await getCompanies(null, null);
  await getSolicitantes();
  // await getEmpleadoComprador();
  // await getBodegasBuscador();

  if (localStorage.getItem("empresaSel") != null) {
    empresaSel.value = JSON.parse(localStorage.getItem("empresaSel") ?? "");

    if (empresaSel.value != null) {
      await getDepartamentos(empresaSel.value?.id, null);
      await getVendors(empresaSel.value?.id);
      await getCeco(empresaSel.value?.id);
      await getCompradores(empresaSel.value?.id);
      await getProyectos(empresaSel.value?.id, null);
    }
  } else {
    empresaSel.value = null;
  }

  localStorage.getItem("departamento") != null
    ? (departamentoSel.value = JSON.parse(
        localStorage.getItem("departamento") ?? ""
      ))
    : (departamentoSel.value = null);

  localStorage.getItem("solId") != null
    ? (solId.value = localStorage.solId)
    : (solId.value = "");

  localStorage.getItem("ingresado") != null
    ? (solicitantePor.value = JSON.parse(
        localStorage.getItem("ingresado") ?? ""
      ))
    : (solicitantePor.value = null);

  localStorage.getItem("solicitante") != null
    ? (solicitante.value = JSON.parse(
        localStorage.getItem("solicitante") ?? ""
      ))
    : (solicitante.value = null);

  localStorage.getItem("tipoSol") != null
    ? (tipoSol.value = JSON.parse(localStorage.getItem("tipoSol") ?? ""))
    : (tipoSol.value = { id: "Todos", nombre: "Todos" });

  if (localStorage.getItem("bodega") != null) {
    if (empresaSel.value?.id !== undefined) {
      // await getBodegas(empresaSel.value?.id);
      await getBodegasBuscador();
    }
    bodegaSel.value = JSON.parse(localStorage.getItem("bodega") ?? "");
  } else {
    bodegaSel.value = null;
  }

  localStorage.getItem("bc365") != null
    ? (bc365.value = localStorage.bc365)
    : (bc365.value = "");

  // console.log("desde: " + localStorage.getItem("desde"));
  if (
    // localStorage.getItem("desde") != null ||
    // localStorage.getItem("desde") != ""
    localStorage.desde != null &&
    localStorage.desde != ""
  ) {
    desde.value = localStorage.desde;
  } else {
    // if (localStorage.getItem("desde") == null) {
    //   desde.value = "";
    // } else {
    desde.value = moment(
      new Date(Date.now() - 90 * 24 * 60 * 60 * 1000)
    ).format("yyyy-MM-DD");
    // }
  }

  // console.log("hasta: " + localStorage.getItem("hasta"));
  // if (
  // localStorage.getItem("hasta") != null
  //   localStorage.hasta != null &&
  //   localStorage.hasta != ""
  // ) {
  //   hasta.value = localStorage.hasta;
  // } else {
  // if (localStorage.getItem("hasta") == null) {
  //   hasta.value = "";
  // } else {
  hasta.value = moment(
    new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
  ).format("yyyy-MM-DD");
  // }
  // }

  localStorage.getItem("estadoSel") != null
    ? (estadoSel.value = JSON.parse(localStorage.getItem("estadoSel") ?? ""))
    : (estadoSel.value = { id: "Todos", nombre: "Todos" });

  localStorage.getItem("comprador") != null
    ? (compradorSel.value = JSON.parse(localStorage.getItem("comprador") ?? ""))
    : (compradorSel.value = null);

  localStorage.getItem("proveedor") != null
    ? (vendorSel.value = JSON.parse(localStorage.getItem("proveedor") ?? ""))
    : (vendorSel.value = null);

  localStorage.getItem("ceco") != null
    ? (cecoSel.value = JSON.parse(localStorage.getItem("ceco") ?? ""))
    : (cecoSel.value = null);

  localStorage.getItem("proyecto") != null
    ? (proyectoSel.value = JSON.parse(localStorage.getItem("proyecto") ?? ""))
    : (proyectoSel.value = null);

  if (cookies.get("username") != "") {
    await obtenerEmpleado(cookies.get("username"));
    // await obtenerEmpleado("paguilera@compasmarine.cl");
  }

  mountedFinish.value = true;
});

async function getBodegasBuscador() {
  try {
    await axios
      .get(store.state.url + "api/Location/GetLocationsBuscador", {
        headers: {},
      })
      .then((response) => {
        if (response.status == 200) {
          lstBodegas.value = response.data as Location[];
          // console.log(lstBodegas.value);
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error) {
        console.log(error.message);
      });
  } catch (error) {
    console.log(error);
  }
}

async function obtenerEmpleado(email: string) {
  try {
    isLoading.value = true;

    await axios
      .get(store.state.url + "api/Empleado/GetEmpleadoXEmail?email=" + email, {
        headers: {},
      })
      .then(async (response) => {
        rut = response.data.rut;
        currentUser.value = response.data.rut;

        var roles = await getRol(email);
        if (response.status == 200) {
          if (
            roles != null &&
            roles?.length > 0 &&
            roles.some((r) => r.rolNombre === "Administrador")
          ) {
            esAdmin.value = true;
          } else esAdmin.value = false;

          if (roles != null && roles.some((r) => r.rolNombre === "Aprobador")) {
            esAprobador.value = true;
          } else esAprobador.value = false;

          if (
            roles != null &&
            roles.some((r) => r.rolNombre === "Aprobador RESPEL")
          ) {
            esAprobadorRespel.value = true;
          } else esAprobadorRespel.value = false;

          if (
            roles != null &&
            roles.some((r) => r.rolNombre === "Autorizador")
          ) {
            esAutorizador.value = true;
          } else esAutorizador.value = false;

          if (roles != null && roles.some((r) => r.rolNombre === "Comprador")) {
            esComprador.value = true;
          }

          if (
            roles != null &&
            roles.some((r) => r.rolNombre === "Contabilidad")
          ) {
            esContabilidad.value = true;
          }

          if (roles != null && roles.some((r) => r.rolNombre === "Bodega")) {
            esBodeguero.value = true;
          }

          if (
            roles != null &&
            roles.some((r) => r.rolNombre === "Visualizador")
          ) {
            esVisualizador.value = true;
          }

          if (
            roles != null &&
            roles.some((r) => r.rolNombre === "Visor Rendiciones")
          ) {
            esVisorRendiciones.value = true;
          }

          if (
            !esAprobador.value &&
            !esAprobadorRespel.value &&
            !esAutorizador.value &&
            !esBodeguero.value &&
            !esContabilidad.value &&
            !esComprador.value &&
            !esVisualizador.value &&
            !esVisorRendiciones.value
            //&& !esAdmin.value
          ) {
            solicitantePor.value =
              lstSolicitantes.value.find((x) => x.email == email) || null;
          }
        }

        // Cargar tipos disponibles según lista blanca/rol
        await cargarTipoSolicitudes();

        await buscarSolicitudClick({ page: 1, itemsPerPage: itemsPerPage.value, sortBy });

        // console.log("fin");
        isLoading.value = false;
      })
      .catch(function (error) {
        console.log(error.message);
      });
  } catch (error) {
    console.log(error);
  }
}

async function selectCompany() {
  try {
    isLoading.value = true;
    departamentoSel.value = null;
    lstDepartamento.value = [];

    if (empresaSel.value != null) {
      await getDepartamentos(empresaSel.value.id, null);
      await getVendors(empresaSel.value.id);
      await getCeco(empresaSel.value.id);
      await getCompradores(empresaSel.value.id);
      await getProyectos(empresaSel.value.id, null);
      // await getBodegasBuscador();
      // await getBodegas(empresaSel.value.id);
    }
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}


async function cargarTipoSolicitudes() {
  try {
    if (!rut) return;

    await axios
      .get(store.state.url + "api/SolicitudCompra/GetTipoSolicitudes?rut=" + rut, {
        headers: {},
      })
      .then((response) => {
        if (response.status == 200) {
          const tipos = (response.data as TipoSolicitud[]) || [];
          if (tipos.length > 0) {
            // API may already include a 'Todos' entry; avoid duplicating it
            if (tipos.some((t) => t.id === "Todos")) {
              lstTipoSolicitud = tipos;
            } else {
              lstTipoSolicitud = [{ id: "Todos", nombre: "Todos" }].concat(tipos);
            }
          } else {
            // Respect backend: if API returns empty (no lista blanca), propagate empty list.
            lstTipoSolicitud = tipos;
          }

          // Restaurar selección previa si sigue vigente
          if (localStorage.getItem("tipoSol") != null) {
            try {
              const saved = JSON.parse(localStorage.getItem("tipoSol") ?? "");
              if (saved != null && lstTipoSolicitud.some((t) => t.id == saved.id)) {
                tipoSol.value = lstTipoSolicitud.find((t) => t.id == saved.id) || lstTipoSolicitud[0];
              } else {
                tipoSol.value = lstTipoSolicitud[0];
                localStorage.removeItem("tipoSol");
              }
            } catch (e) {
              tipoSol.value = lstTipoSolicitud[0];
            }
          } else {
            tipoSol.value = lstTipoSolicitud[0];
          }
        }
      })
      .catch((e) => {
        console.log(e.message);
      });
  } catch (error) {
    console.log(error);
  }
}

async function selectClear() {
  departamentoSel.value = null;
  lstDepartamento.value = [];
}

async function seleccionarRetiroBodega() {
  if (tipoSol.value?.id === "Retiro Bodega" /*&& empresaSel.value != null*/) {
    // await getBodegas(empresaSel.value?.id);
    await getBodegasBuscador();
  } else {
    lstBodegas.value = [];
    bodegaSel.value = null;
  }
}

function limpiarBusqueda() {
  // date.value = "";

  desde.value = moment(new Date(Date.now() - 90 * 24 * 60 * 60 * 1000)).format(
    "yyyy-MM-DD"
  );

  hasta.value = moment(
    new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
  ).format("yyyy-MM-DD");

  // desde.value = "";
  // hasta.value = "";

  empresaSel.value = null;
  departamentoSel.value = null;
  lstDepartamento.value = [];
  lstBodegas.value = [];
  lstCeco.value = [];
  lstProyectos.value = [];
  solId.value = "";
  solicitante.value = null;
  lstDetalle.value = [];
  bc365.value = "";
  bodegaSel.value = null;
  proyectoSel.value = null;
  // solicitantePor.value = null;
  tipoSol.value = { id: "Todos", nombre: "Todos" };
  estadoSel.value = { id: "Todos", nombre: "Todos" };
  compradorSel.value = null;
  vendorSel.value = null;
  cecoSel.value = null;

  localStorage.removeItem("empresaSel");
  localStorage.removeItem("departamento");
  localStorage.removeItem("solId");
  localStorage.removeItem("ingresado");
  localStorage.removeItem("solicitante");
  localStorage.removeItem("tipoSol");
  localStorage.removeItem("bodega");
  localStorage.removeItem("bc365");
  localStorage.setItem("desde", desde.value);
  localStorage.setItem("hasta", hasta.value);

  localStorage.removeItem("estadoSel");
  localStorage.removeItem("comprador");
  localStorage.removeItem("proveedor");
  localStorage.removeItem("ceco");
  localStorage.removeItem("proyecto");
}

async function buscarSolicitudClick({ page, itemsPerPage, sortBy }: { page: number; itemsPerPage: number; sortBy: any }) {
  page = 1;
  itemsPerPage = 10;
  sortBy = null;

  buscarSolicitud({ page, itemsPerPage, sortBy }, true);
}

async function buscarSolicitud(
  { page, itemsPerPage, sortBy }: { page: number; itemsPerPage: number; sortBy: any },
  flag: boolean
) {
  if (!page) {
    return;
  }

  if (!itemsPerPage) {
    return;
  }

  // console.log("mountedFinish:");
  // console.log(mountedFinish.value);
  if (flag == true) {
    // console.log("true");
  } else {
    if (page == 1 && itemsPerPage == 10 && !mountedFinish.value) {
      return;
    }
  }

  if (!sortBy) {
    orderP.value = "desc";
    keyOrderP.value = "code";
  } else {
    if (sortBy[0]) {
      orderP.value = sortBy[0].order;
      keyOrderP.value = sortBy[0].key;
    } else {
      orderP.value = "desc";
      keyOrderP.value = "code";
    }
  }

  isLoading.value = true;
  try {
    var url =
      store.state.url +
      "api/SolicitudCompra/BuscarSolicitudCompra?pagina=" +
      page +
      "&cantidad=" +
      itemsPerPage +
      "&order=" +
      orderP.value +
      "&keyOrderParam=" +
      keyOrderP.value +
      "&estado=" +
      estadoSel.value?.id +
      "&rut=" +
      rut +
      "&email=" +
      // "paguilera@compasmarine.cl";
      cookies.get("username");

    localStorage.setItem("estadoSel", JSON.stringify(estadoSel.value));

    // if (date.value != "" && date.value != null) {
    //   url = url + "&fecha=" + date.value;
    //   localStorage.setItem("fecha", date.value);
    // }

    if (desde.value && hasta.value) {
      url = url + "&desde=" + desde.value + "&hasta=" + hasta.value;
      localStorage.setItem("desde", desde.value);
      localStorage.setItem("hasta", hasta.value);
    } else {
      localStorage.removeItem("desde");
      localStorage.removeItem("hasta");
      if (desde.value && !hasta.value) {
        url = url + "&desde=" + desde.value;

        localStorage.setItem("desde", desde.value);
        localStorage.removeItem("hasta");
        // localStorage.setItem("hasta", "empty");
      }

      if (!desde.value && hasta.value) {
        url = url + "&hasta=" + hasta.value;

        // localStorage.setItem("desde", "empty");
        localStorage.removeItem("desde");
        localStorage.setItem("hasta", hasta.value);
      }

      if (!desde.value && !hasta.value) {
        desde.value = moment(
          new Date(Date.now() - 90 * 24 * 60 * 60 * 1000)
        ).format("yyyy-MM-DD");
        hasta.value = moment(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        ).format("yyyy-MM-DD");
        url = url + "&desde=" + desde.value + "&hasta=" + hasta.value;
        localStorage.setItem("desde", desde.value);
        localStorage.setItem("hasta", hasta.value);
      }
    }

    if (empresaSel.value != null) {
      url = url + "&empresa=" + empresaSel.value.id;
      localStorage.setItem("empresaSel", JSON.stringify(empresaSel.value));
    }

    if (departamentoSel.value != null) {
      url = url + "&departamento=" + departamentoSel.value.id;
      localStorage.setItem(
        "departamento",
        JSON.stringify(departamentoSel.value)
      );
    }

    if (solId.value != "" && solId.value != null) {
      url = url + "&solId=" + solId.value;
      localStorage.setItem("solId", solId.value);
    } else {
      localStorage.removeItem("solId");
    }

    if (solicitantePor.value != null) {
      url = url + "&ingresado=" + solicitantePor.value.rut;
      // localStorage.setItem("ingresado", JSON.stringify(solicitantePor.value));
    }

    if (solicitante.value != null) {
      url = url + "&solicitante=" + solicitante.value.rut;
      localStorage.setItem("solicitante", JSON.stringify(solicitante.value));
    }

    if (tipoSol.value != null) {

      localStorage.setItem("tipoSol", JSON.stringify(tipoSol.value));
      if (tipoSol.value.id !== "Todos") {
        url = url + "&tipoSol=" + tipoSol.value.id;
      }
    }

    if (bodegaSel.value != null) {
      url = url + "&bodega=" + bodegaSel.value.code;
      localStorage.setItem("bodega", JSON.stringify(bodegaSel.value));
    }

    if (bc365.value != "" && bc365.value != null) {
      url = url + "&bc365=" + bc365.value;
      localStorage.setItem("bc365", bc365.value);
    }

    if (compradorSel.value != null) {
      url = url + "&comprador=" + compradorSel.value.code;
      localStorage.setItem("comprador", JSON.stringify(compradorSel.value));
    }

    if (vendorSel.value != null) {
      url = url + "&proveedor=" + vendorSel.value.number;
      localStorage.setItem("proveedor", JSON.stringify(vendorSel.value));
    }

    if (cecoSel.value != null) {
      url = url + "&ceco=" + cecoSel.value.id;
      localStorage.setItem("ceco", JSON.stringify(cecoSel.value));
    }

    if (proyectoSel.value != null) {
      url = url + "&proyecto=" + proyectoSel.value.id;
      localStorage.setItem("proyecto", JSON.stringify(proyectoSel.value));
    }
    await axios
      .get(url, { headers: { "Access-Control-Allow-Origin": "*" } })
      .then(async (response) => {
        if (response.status == 200) {
          const respData = (response.data as BuscarSolicitud[]) || [];

          // console.log("respData:", JSON.stringify(respData));

          respData.forEach((d) => {
            if (d) {
              d.tipoSolicitudId = normalizeTipoSolicitud(d.tipoSolicitudId);
            }
          });

          lstDetalle.value = respData;

          if (lstDetalle.value.length > 0) {
            totalItems.value = lstDetalle.value[0].cantidadTotal ?? lstDetalle.value.length ?? 0;
          } else {
            totalItems.value = 0;
          }

          var roles = await getRol(cookies.get("username")); //
          // var roles = await getRol('paguilera@compasmarine.cl');
          if (roles != null && roles.some((r) => r.rolNombre === "Comprador")) {
            esComprador.value = true;
            esAprobador.value = false;
          }
        } else {
          console.log(response.statusText);
        }
      })
      .catch(function (error) {
        console.log(error.message);
      });
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

async function exportarSolicitudClick({ page, itemsPerPage, sortBy }: { page: number; itemsPerPage: number; sortBy: any }) {
  if (totalItems.value == 0) {
    swal.fire(
      "No hay datos para exportar",
      "Realice una búsqueda que arroje resultados",
      "warning"
    );
    return;
  }

  page = 1;
  itemsPerPage = totalItems.value;
  sortBy = null;

  exportarSolicitud({ page, itemsPerPage, sortBy }, true);
}

async function exportarSolicitud(
  { page, itemsPerPage, sortBy }: { page: number; itemsPerPage: number; sortBy: any },
  flag: boolean
) {
  if (!page) {
    return;
  }

  if (!itemsPerPage) {
    return;
  }

  // console.log("mountedFinish:");
  // console.log(mountedFinish.value);
  if (flag == true) {
    // console.log("true");
  } else {
    if (page == 1 && itemsPerPage == 10 && !mountedFinish.value) {
      return;
    }
  }

  if (!sortBy) {
    orderP.value = "desc";
    keyOrderP.value = "code";
  } else {
    if (sortBy[0]) {
      orderP.value = sortBy[0].order;
      keyOrderP.value = sortBy[0].key;
    } else {
      orderP.value = "desc";
      keyOrderP.value = "code";
    }
  }

  isLoading.value = true;
  try {
    var url =
      store.state.url +
      "api/SolicitudCompra/ExportarBusqueda?pagina=" +
      page +
      "&cantidad=" +
      itemsPerPage +
      "&order=" +
      orderP.value +
      "&keyOrderParam=" +
      keyOrderP.value +
      "&estado=" +
      estadoSel.value?.id +
      "&rut=" +
      rut +
      "&email=" +
      // "paguilera@compasmarine.cl";
      cookies.get("username");

      
    localStorage.setItem("estadoSel", JSON.stringify(estadoSel.value));

    // if (date.value != "" && date.value != null) {
    //   url = url + "&fecha=" + date.value;
    //   localStorage.setItem("fecha", date.value);
    // }

    if (desde.value && hasta.value) {
      url = url + "&desde=" + desde.value + "&hasta=" + hasta.value;
      localStorage.setItem("desde", desde.value);
      localStorage.setItem("hasta", hasta.value);
    } else {
      localStorage.removeItem("desde");
      localStorage.removeItem("hasta");
      if (desde.value && !hasta.value) {
        url = url + "&desde=" + desde.value;

        localStorage.setItem("desde", desde.value);
        localStorage.removeItem("hasta");
        // localStorage.setItem("hasta", "empty");
      }

      if (!desde.value && hasta.value) {
        url = url + "&hasta=" + hasta.value;

        // localStorage.setItem("desde", "empty");
        localStorage.removeItem("desde");
        localStorage.setItem("hasta", hasta.value);
      }

      if (!desde.value && !hasta.value) {
        desde.value = moment(
          new Date(Date.now() - 90 * 24 * 60 * 60 * 1000)
        ).format("yyyy-MM-DD");
        hasta.value = moment(
          new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        ).format("yyyy-MM-DD");
        url = url + "&desde=" + desde.value + "&hasta=" + hasta.value;
        localStorage.setItem("desde", desde.value);
        localStorage.setItem("hasta", hasta.value);
      }
    }

    if (empresaSel.value != null) {
      url = url + "&empresa=" + empresaSel.value.id;
      localStorage.setItem("empresaSel", JSON.stringify(empresaSel.value));
    }

    if (departamentoSel.value != null) {
      url = url + "&departamento=" + departamentoSel.value.id;
      localStorage.setItem(
        "departamento",
        JSON.stringify(departamentoSel.value)
      );
    }

    if (solId.value != "" && solId.value != null) {
      url = url + "&solId=" + solId.value;
      localStorage.setItem("solId", solId.value);
    } else {
      localStorage.removeItem("solId");
    }

    if (solicitantePor.value != null) {
      url = url + "&ingresado=" + solicitantePor.value.rut;
      // localStorage.setItem("ingresado", JSON.stringify(solicitantePor.value));
    }

    if (solicitante.value != null) {
      url = url + "&solicitante=" + solicitante.value.rut;
      localStorage.setItem("solicitante", JSON.stringify(solicitante.value));
    }

    if (tipoSol.value != null) {
      localStorage.setItem("tipoSol", JSON.stringify(tipoSol.value));
      if (tipoSol.value.id !== "Todos") {
        url = url + "&tipoSol=" + tipoSol.value.id;
      }
    }

    if (bodegaSel.value != null) {
      url = url + "&bodega=" + bodegaSel.value.code;
      localStorage.setItem("bodega", JSON.stringify(bodegaSel.value));
    }

    if (bc365.value != "" && bc365.value != null) {
      url = url + "&bc365=" + bc365.value;
      localStorage.setItem("bc365", bc365.value);
    }

    if (compradorSel.value != null) {
      url = url + "&comprador=" + compradorSel.value.code;
      localStorage.setItem("comprador", JSON.stringify(compradorSel.value));
    }

    if (vendorSel.value != null) {
      url = url + "&proveedor=" + vendorSel.value.number;
      localStorage.setItem("proveedor", JSON.stringify(vendorSel.value));
    }

    if (cecoSel.value != null) {
      url = url + "&ceco=" + cecoSel.value.id;
      localStorage.setItem("ceco", JSON.stringify(cecoSel.value));
    }

    if (proyectoSel.value != null) {
      url = url + "&proyecto=" + proyectoSel.value.id;
      localStorage.setItem("proyecto", JSON.stringify(proyectoSel.value));
    }

    await axios
      .get(url, {
        headers: { "Access-Control-Allow-Origin": "*" },
        responseType: "blob",
      })
      .then(async (response) => {
        let title = "Listado_Solicitudes_" + moment().format("DDMMyyyyHHmmss") + ".xlsx";

        forceFileDownload(response, title);
      })
      .catch(function (error) {
        console.log(error.message);
      });
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
}

async function getRol(email: string) {
  try {
    let tiene: Rol[] = [];

    await axios
      .get(store.state.url + "api/Rol/GetRol?email=" + email, {
        headers: {},
      })
      .then((response) => {
        if (response.status == 200) {
          tiene = response.data as Rol[];
        } else {
          console.log(response.statusText);
          tiene = [];
        }
      })
      .catch(function (error) {
        console.log(error.message);
        tiene = [];
      });

    return tiene;
  } catch (error) {
    console.log(error);
  }
}

function formatDate(value: string) {
  return moment(value).format("DD-MM-yyyy");
}

function formatTotal(value: number) {
  return new Intl.NumberFormat("es-CL", {
    style: "currency",
    currency: "CLP",
  }).format(value);
}

function navigate(item: BuscarSolicitud) {
  if (item.estado === "Guardada") {
    // router.push({
    //   name: "EditarSolicitud",
    //   params: { solicitudId: item.id },
    // });
    router.push({
      path: "/EditarSolicitud",
      query: {
        id: item.id,
      },
    });
  } else {
    // router.push({
    //   name: "DetalleSolicitud",
    //   params: { solicitudId: item.id },
    // });
    router.push({
      path: "/DetalleSolicitud",
      query: { id: item.id },
    });
  }
}

function forceFileDownload(response: any, title: string) {
  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = title;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
</script>
